import API from '@/shared/plugins/Api/API'

class CacheV3 extends API {
  constructor (id) {
    super(id)
    this.prefix = '/public/v1'
  }

  _appUrl (appName) {
    return `${this.prefix}/application/${encodeURIComponent(appName)}`
  }

  // Allowed cache images catalog — never hardcode versions, the catalog evolves.
  async getCapabilities () {
    return this.request({
      method: 'get',
      url: `${this.prefix}/capabilities/cache`
    })
  }

  async getConfig (appName) {
    return this.request({
      method: 'get',
      url: `${this._appUrl(appName)}/cache`
    })
  }

  // Any change marks STARTED deployments as needing a restart.
  async updateConfig (appName, cache) {
    return this.request({
      method: 'put',
      url: `${this._appUrl(appName)}/cache`,
      data: cache
    })
  }
}

export default CacheV3
